import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import { Icon, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { iconsList } from "../../data/icons";

const DEFAULT_MARGIN = 16;

const useStyles = makeStyles((theme) => ({
  faIconPicker: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: DEFAULT_MARGIN,
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
  faIconPickerPlace: {
    border: `1px solid grey`,
    borderRadius: 5,
    marginLeft: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 5,
    minHeight: 51,
    maxHeight: 51,
    minWidth: 51,
    maxWidth: 51,
  },
}));

const commonIcon = {
  width: "auto",
  height: "auto",
  padding: 1,
};

export const DEFAULT_BAND_NOT_ICON = 533;

export default function FaIconsGrid({ handleChangeSelectedIcon }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = useState(iconsList[DEFAULT_BAND_NOT_ICON]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    handleChangeSelectedIcon(value?.icon);
  }, [value, handleChangeSelectedIcon]);

  return (
    <div className={classes.faIconPicker}>
      <Autocomplete
        id="icon-select"
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        options={iconsList}
        classes={{
          option: classes.option,
        }}
        autoHighlight
        getOptionLabel={(option) => option.icon}
        renderOption={(option) => (
          <>
            <Icon className={option.icon} style={commonIcon} />
            <Typography>{option.icon}</Typography>
          </>
        )}
        style={{ width: "100%" }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t("CUSTOM_HOME_CHOOSE_ICON")}
            variant="outlined"
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
            }}
          />
        )}
      />
      {value && value?.icon && (
        <div className={classes.faIconPickerPlace}>
          <Icon
            className={value?.icon}
            style={{ ...commonIcon, fontSize: "1.40rem" }}
          />
        </div>
      )}
    </div>
  );
}
